const initBackgroundColorWallpaperImageAndText = () => {
    const wallpaperImageAndTextWidgetsArray = document.querySelectorAll(".wallpaper-image-and-text-widget");
    if (wallpaperImageAndTextWidgetsArray && wallpaperImageAndTextWidgetsArray.length > 0) {
        wallpaperImageAndTextWidgetsArray.forEach((wallpaperImageAndTextWidget) => {
            const textContainer = wallpaperImageAndTextWidget.querySelector(".text-container");
            if (window.innerWidth <= 767) {
                if (textContainer) {
                    textContainer.style.backgroundColor = `#${textContainer.getAttribute("data-bg-color")}`;
                }
                else {
                    return;
                }
            }
        });
    }
};
